module.exports = __webpack_public_path__ + "assets/img/home_top.7076b99c.png";